<div class="bg-orange-100 p-2 flex flex-col">
    <div class="bg-orange-100 text-gray-900 text-center">
        In the timeline, all learning questions and activities are represented as events. The slider of each event
        contains
        details about it and corresponds to the following colour palette:
    </div>
    <ul class="place-self-center mt-2">
        <li class="lq"><span style="display: inline-block; width: 15px; height: 15px; background-color: #99c199;"></span> Learning Questions</li>
        <li class="cia"><span style="display: inline-block; width: 15px; height: 15px; background-color: #648528;"></span> Consumption</li>
        <li class="gia"><span style="display: inline-block; width: 15px; height: 15px; background-color: #105128ed;"></span> Governance</li>
        <li class="dia"><span style="display: inline-block; width: 15px; height: 15px; background-color: #59C6F2;"></span> Distribution</li>
        <li class="pia"><span style="display: inline-block; width: 15px; height: 15px; background-color: #0F70B7;"></span> Production</li>
        <li class="wia"><span style="display: inline-block; width: 15px; height: 15px; background-color: #C7D40B;"></span> Food Waste</li>
    </ul>
</div>